// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WizardServicos_EntrouSemProblemasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type WizardServicos_EntrouSemProblemasResponseDados = boolean;

export type WizardServicos_EntrouSemProblemasResponse = ApiResponse<WizardServicos_EntrouSemProblemasResponseDados>;

registerResponseContract('WizardServicos_EntrouSemProblemasResponse', {})
